<template>
  <div>
    <BulkOpsHeader
      @new="newDialog = true"
    >
      Form Operations
    </BulkOpsHeader>
    <BulkOpsTable
      :rows.sync="formOps"
      :headers="headers"
      :totalRows="pagination.totalRows"
      :pagination="pagination"
      @fetch="pagination=arguments[0]"
    >
      <template v-slot:default="prop">
        <td>
          {{prop.row.count}}
        </td>
        <td>
          <div
            v-if="JSON.parse(prop.row.update_json).add_tags"
          >
            <b>Add Tags: </b>
            <v-chip
              v-for="tag in JSON.parse(prop.row.update_json).add_tags"
              :key="tag"
              small
            >
              {{tag}}
            </v-chip>
          </div>
          <div
            v-if="JSON.parse(prop.row.update_json).remove_tags"
          >
            <b>Remove Tags: </b>
            <v-chip
              v-for="tag in JSON.parse(prop.row.update_json).remove_tags"
              :key="tag"
              small
              outline
            >
              {{tag}}
            </v-chip>
          </div>
          <div
            v-if="JSON.parse(prop.row.update_json).remove_all_tags"
          >
            <b>Remove All Tags</b>
          </div>
          <div
            v-if="JSON.parse(prop.row.update_json).update_status"
          >
            <b>Change Status to </b>{{JSON.parse(prop.row.update_json).update_status}}
          </div>
        </td>
        <td style="text-transform: capitalize;">
          {{prop.row.status}}
        </td>
      </template>
    </BulkOpsTable>
    <BulkOpsDialog
      v-if="newDialog"
      title="New Bulk Form Operation"
      :update_actions="bulkOpActions"
      @save="save(arguments[0])"
      @cancel="newDialog = false"
    />
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import GlobalConstants from '@/globals'
import pagination from '@/components/global/pagination'
import BulkOpsHeader from '@/components/admin/bulkops/BulkOpsHeader'
import BulkOpsTable from '@/components/admin/bulkops/BulkOpsTable'
import BulkOpsDialog from '@/components/admin/bulkops/BulkOpsDialog'
import { mapGetters } from 'vuex'

export default {
  name: 'UserFormBulkOps',
  components: {
    BulkOpsHeader,
    BulkOpsTable,
    BulkOpsDialog
  },
  mixins: [
    pagination
  ],
  data () {
    return {
      formOps: [],
      loading: false,
      pagination: {},
      totalRows: null,
      pages: null,
      newDialog: false,
      interval: null,
      headers: [
        { text: 'Count', width: 20, sortable: false },
        { text: 'Action', width: 180, sortable: false },
        { text: 'Status', width: 60, sortable: false },
        { text: 'Run Time', width: 60, sortable: false },
        { text: 'Progress', width: 60, sortable: false },
      ],
      bulkOpActions: [
        {
          "title": "Add Tags",
          "prop": "add_tags",
          "type": "tags",
          "type_scope": "userform",
          "value": null,
          "hint": "Add this existing or new tag to all forms entered"
        },
        {
          "title": "Remove Tags",
          "prop": "remove_tags",
          "type": "tags",
          "type_scope": "userform",
          "value": null,
          "hint": "Remove this existing tag from all forms entered"
        },
        {
          "title": "Remove All Tags",
          "prop": "remove_all_tags",
          "type": "checkbox",
          "value": null,
          "hint": "Remove all tags from a form"
        },
        {
          "title": "Update Status",
          "prop": "update_status",
          "type": "dropdown",
          "options": null,
          "value": null,
          "hint": "Set all forms to this status"
        }
      ]
    }
  },
  created () {
    this.documentTitle('Form Operations')
  },
  computed: {
    ...mapGetters('auth', [
        'getDomainInfo',
      ]
    )
  },
  watch: {
    getDomainInfo: {
      handler(){
        this.bulkOpActions[3].options = this.checkForOutage()
      },
      immediate: true
    }
  },
  methods: {
    restartInterval () {
      clearInterval(this.interval)
      var countWorking = 0
      this.formOps.forEach((item) => {
        if (["finished", "failed"].indexOf(item.status) == -1)
          countWorking++
      })
      if (countWorking > 0) {
        this.interval = setInterval(() => {
          this.fetch()
        }, 5000)
      }
    },
    fetch () {
      this.loading = true
      api.bulkops.userform.list({
        pageNum: this.pagination.page, count: this.pagination.rowsPerPage, ordering: '-created_at'
      })
        .then(data => {
          this.formOps = data.results
          this.pagination.totalRows = data.count
          this.pagination.page = data.page_number
          this.loading = false
          this.componentCreated = true
          this.restartInterval()
        })
    },
    save (newOp) {
      var userform_ids = []
      var update_json = {}
      newOp.update.split(/\r?\n/).forEach((id) => {
        if (id !== "") {
          userform_ids.push(parseInt(id))
        }
      })
      newOp.props.forEach((prop) => {
        if (prop.value !== null && prop.value !== "") {
          update_json[prop.prop] = prop.value
        }
      })
      api.bulkops.userform.save({userform_ids: JSON.stringify(userform_ids),
                                 update_json: JSON.stringify(update_json)})
      .then(() => {
        this.newDialog = false
        this.fetch()
      })
    },
    checkForOutage(){
      if('outage' in this.getDomainInfo && this.getDomainInfo.outage.includes("sign")){
        return GlobalConstants.StatusStrings.filter( status => {
          return status.name != "Request E-Signature"
        })  
      } else {
        return GlobalConstants.StatusStrings
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  }
}
</script>
